import { render, staticRenderFns } from "./Design.vue?vue&type=template&id=bd058fe2&scoped=true"
import script from "./Design.vue?vue&type=script&lang=js"
export * from "./Design.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd058fe2",
  null
  
)

export default component.exports